module.exports = __webpack_public_path__ + "static/media/Impreza-GJ-Sedan.3ad2da90.webp";